import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import ReportHistory from '../views/ReportHistory.vue'
import Researchers from '../views/Researchers.vue'
import About from '../views/About.vue'
import Signup from '@/components/auth/Signup.vue'
import Login from '@/components/auth/Login.vue'
import {auth, db} from '@/fb'
import TicketDetail from '@/components/tickets/TicketDetail.vue'
import TicketReport from '@/components/tickets/TicketReport.vue'
import UserProfile from '@/components/users/UserProfile.vue'
import GoVerifyEmail from '@/components/auth/GoVerifyEmail.vue'
import ticketAssignment from '../views/TicketAssignment.vue'
import LicenseApplications from '../views/LicenseApplications.vue'

Vue.use(VueRouter)
/* eslint-disable no-console */
const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    beforeEnter: async (to,from,next)=>{
      var userEmailList = []
      let ref = db.collection('users')
      await ref.get().then(snap=>{
        snap.forEach(doc=>{
          userEmailList.push(doc.data().email)
        })
      })
      let user=auth.currentUser
      if(userEmailList.includes(user.email)){
        next()
      }else{
        next({name:'login'})
      }
    },
    meta:{
      requireAuth:true,
    },
  },
  {
    path: '/report-history',
    name: 'ReportHistory',
    component: ReportHistory,
    beforeEnter: async (to,from,next)=>{
      var userEmailList = []
      let ref = db.collection('users')
      await ref.get().then(snap=>{
        snap.forEach(doc=>{
          userEmailList.push(doc.data().email)
        })
      })
      let user=auth.currentUser
      if(userEmailList.includes(user.email)){
        next()
      }else{
        next({name:'login'})
      }
    },
    meta:{
      requireAuth:true,
    },
  },
  {
    path: '/researchers',
    name: 'researchers',
    component: Researchers,
    beforeEnter: async (to,from,next)=>{
      var userEmailList = []
      let ref = db.collection('users')
      await ref.get().then(snap=>{
        snap.forEach(doc=>{
          userEmailList.push(doc.data().email)
        })
      })
      let user=auth.currentUser
      if(userEmailList.includes(user.email)){
        next()
      }else{
        next({name:'login'})
      }
    },
    meta:{
      requireAuth:true,
    },
  },
  {
    path: '/license-applications',
    name: 'licenseApplications',
    component: LicenseApplications,
    beforeEnter: async (to,from,next)=>{
      var userEmailList = []
      let ref = db.collection('users')
      await ref.get().then(snap=>{
        snap.forEach(doc=>{
          userEmailList.push(doc.data().email)
        })
      })
      let user=auth.currentUser
      if(userEmailList.includes(user.email)){
        next()
      }else{
        next({name:'login'})
      }
    },
    meta:{
      requireAuth:true,
    },
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta:{
      requireAuth:true,
    },
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/email-verification',
    name: 'emailverification',
    component: GoVerifyEmail
  },
  {
    path: '/edit_reports/:id/:ticket_id',
    name: 'TicketDetail',
    component: TicketDetail,
    beforeEnter: async (to,from,next)=>{
      var userEmailList = []
      let ref = db.collection('users')
      await ref.get().then(snap=>{
        snap.forEach(doc=>{
          userEmailList.push(doc.data().email)
        })
      })
      let user=auth.currentUser
      if(userEmailList.includes(user.email)){
        next()
      }else{
        next({name:'login'})
      }
    },
    meta:{
      requireAuth:true,
    },
  },
  {
    path: '/reports/:id/:ticket_id',
    name: 'TicketReport',
    component: TicketReport,
  },
  {
    path: '/profile/:id',
    name: 'UserProfile',
    component: UserProfile,
    props:true,
    beforeEnter: async (to,from,next)=>{
      var userEmailList = []
      let ref = db.collection('users')
      await ref.get().then(snap=>{
        snap.forEach(doc=>{
          userEmailList.push(doc.data().email)
        })
      })
      let user=auth.currentUser
      if(userEmailList.includes(user.email)){
        next()
      }else{
        next({name:'login'})
      }
    },
    meta:{
      requireAuth:true,
    }
  },
    {
      path: '/assign-ticket',
      name: 'ticketAssignment',
      component: ticketAssignment,
      beforeEnter: async (to,from,next)=>{
        var userEmailList = []
        let ref = db.collection('users')
        await ref.get().then(snap=>{
          snap.forEach(doc=>{
            userEmailList.push(doc.data().email)
          })
        })
        let user=auth.currentUser
        if(userEmailList.includes(user.email)){
          next()
        }else{
          next({name:'login'})
        }
      },
      meta:{
        requireAuth:true,
      },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next)=>{
  //check to see if route requires auth
  if(to.matched.some(rec=>rec.meta.requireAuth)){
    //check auth state of user
    let user=auth.currentUser
    if(!user){
      next({name:'login'})
    }else if(user.emailVerified){
      next()
    }else{
      next({name:'emailverification'})
    }
    // if(user.emailVerified){
    //   next()
    // }else if(user){
    //   next({name:'emailverification'})
    // }else{
    //   next({name:'login'})
    // }
  }else{
    next()
  }
})

export default router
